$(() => {
  $('.bs-div--use-background-color-opacity').each((index, element) => {
    console.log(element);
    const backgroundColor = $(element).css('background-color');
    $(element).attr({'style':`--bgcolor:${backgroundColor}`});
  });
});